import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  ContentContainer,
  MainContainer,
} from '../../components/atoms/tableData/styles/contentContainer.styles';
import GcspTable from '../../components/templates/gcsp/forecast/tableComponent/gcspTable';
import GcspTableData from '../../components/templates/gcsp/forecast/tableComponent/gcspTableData';
import SubHeaderGcsp from '../../components/molecules/dcsp/components/subHeaderGcsp';
import DashboardAlerts from '../../components/organisms/alertBar/dashboardAlerts';
import SpinnerLoader from '../../components/atoms/SpinnerLoader';
import SubHeaderTopGcsp from '../../components/molecules/dcsp/components/subHeaderTopGcsp';

function GcspForecast() {
  const [isLoading, setIsLoading] = useState(true);
  let screenName = 'forecast';

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(loadingTimer);
  }, []);

  const CenteredSpinner = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `;

  return (
    <>
      <MainContainer>
        <ContentContainer>
          <SubHeaderTopGcsp />
          <SubHeaderGcsp />
          <DashboardAlerts screenName={screenName} />
          {isLoading ? (
            <CenteredSpinner>
              <SpinnerLoader color="#155CB4" />
            </CenteredSpinner>
          ) : (
            <>
              <GcspTable />
            </>
          )}
        </ContentContainer>
      </MainContainer>
    </>
  );
}

export default GcspForecast;
